/* The Mint Workshop — loader dismissal.
   Holds for a floor so it does not flash, never past the ceiling, and clears
   on load whichever comes first. The CSS carries its own failsafe, so a script
   error here still cannot strand anyone behind the overlay. */
(function () {
  'use strict';

  var el = document.querySelector('[data-mw-loader]');
  if (!el || !el.classList.contains('is-on')) return;

  var min = parseInt(el.dataset.min || '420', 10);
  var max = parseInt(el.dataset.max || '900', 10);
  var start = Date.now();
  var done = false;

  function dismiss() {
    if (done) return;
    done = true;
    el.classList.add('is-out');
    try { sessionStorage.setItem('mw-loader-seen', '1'); } catch (e) {}
    setTimeout(function () {
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    }, 420);
  }

  function ready() {
    var waited = Date.now() - start;
    setTimeout(dismiss, Math.max(0, min - waited));
  }

  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready);

  // the ceiling wins regardless of what the page is still doing
  setTimeout(dismiss, max);
})();
